import { FontWeights, makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  verticalCheckbox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    selectors: {
      '.ms-Checkbox-label': {
        fontWeight: FontWeights.semibold,
        marginBottom: 4,
      },
    },
  },

}));
